export default __webpack_public_path__ + "static/media/goncalves.cda76f8b.png";